import {
  OverlayArrow,
  Popover as AriaPopover,
  PopoverProps as AriaPopoverProps,
  composeRenderProps,
} from "react-aria-components";
import React from "react";
import { tv } from "tailwind-variants";
import { cn } from "@/utils/helpers";
import { useCoShellPortal } from "@/app/routes/dashboard/CoShellPortalContext";

export interface PopoverProps extends Omit<AriaPopoverProps, "children"> {
  showArrow?: boolean;
  children: React.ReactNode;
}

const styles = tv({
  base: "font-sans rounded-none border border-co-line2 bg-[var(--co-dropdown-panel-bg)] text-co-text shadow-[var(--shell-shadow,0_8px_24px_rgba(0,0,0,0.45))] outline-0 forced-colors:bg-[Canvas]",
  variants: {
    isEntering: {
      true: "animate-in fade-in zoom-in-97 origin-(--trigger-anchor-point) placement-bottom:slide-in-from-top-1 placement-top:slide-in-from-bottom-1 placement-left:slide-in-from-right-1 placement-right:slide-in-from-left-1",
    },
    isExiting: {
      true: "animate-out fade-out zoom-out-97 origin-(--trigger-anchor-point)",
    },
  },
});

export function Popover({
  children,
  showArrow,
  className,
  ...props
}: PopoverProps) {
  let offset = showArrow ? 12 : 6;
  // Portal into .co-shell so --co-* tokens resolve inside the overlay.
  const portalContainer = useCoShellPortal();
  return (
    <AriaPopover
      offset={offset}
      UNSTABLE_portalContainer={portalContainer ?? undefined}
      {...props}
      className={composeRenderProps(className, (className, renderProps) =>
        styles({ ...renderProps, className: cn("co-dropdown-panel z-[var(--z-index-popover)]", className) }),
      )}
    >
      {showArrow && (
        <OverlayArrow className="group">
          <svg
            width={12}
            height={12}
            viewBox="0 0 12 12"
            className="block fill-[var(--co-dropdown-panel-bg)] forced-colors:fill-[Canvas] stroke-1 stroke-co-line2 forced-colors:stroke-[ButtonBorder] group-placement-bottom:rotate-180 group-placement-left:-rotate-90 group-placement-right:rotate-90"
          >
            <path d="M0 0 L6 6 L12 0" />
          </svg>
        </OverlayArrow>
      )}
      {children}
    </AriaPopover>
  );
}
